'use client';

import { Trans } from '@lingui/macro';
import { Box, Container, Stack, Typography } from '@mui/material';
import { AppPalettes, Button } from '@prismo-io/design-system';
import { ThemeProvider } from '@prismo-io/design-system/theme-provider';
// import { ButtonLink } from '@prismo-io/router';
import type { FC } from 'react';

type Props = unknown;

export const QuestionnairesDisclaimer: FC<Props> = (props: Props) => {
  return (
    <ThemeProvider
      theme={AppPalettes.light}
      options={{ key: 'questionnaire-disclaimer' }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        p={{ none: 2, md: 4 }}
        bgcolor="background.primary"
      >
        <Container>
          <Stack
            direction="column"
            spacing={3}
            p={{ none: '0', lg: '1.5rem 4rem' }}
          >
            <Typography variant="h4" color="primary.main">
              <Trans>À propos de nos questionnaires</Trans>
            </Typography>
            <Typography>
              <Trans>
                Nos questionnaires fournissent des clés pour la compréhension de
                soi, pour apprendre à mieux se connaître et communiquer avec les
                autres, mais ne font pas foi de vérité absolue. Les résultats
                sont donc à prendre avec de la distance. Vos réponses sont
                influencées par votre état d’esprit et votre environnement au
                moment où vous répondez aux questionnaires. Il n’est également
                pas à exclure qu’il puisse y avoir des erreurs de calcul. Un
                accompagnement avec un professionnel vous permettrait de mieux
                comprendre vos résultats et leurs origines.
              </Trans>
            </Typography>
            <Box component="div">
              {/* <ButtonLink
                app={Application.ONBOARDING}
                path="/connexion"
                addHostname
                variant="text"
                color="inherit"
                sx={{ paddingLeft: 0, padding: 0 }}
              > */}
              <Button
                href={'https://prismo.io/faq-prismo/'}
                variant="text"
                color="inherit"
                sx={{ paddingLeft: 0, padding: 0 }}
              >
                <Trans>En savoir plus</Trans>
              </Button>
            </Box>
          </Stack>
        </Container>
      </Stack>
    </ThemeProvider>
  );
};
